import * as types from './mutation-types';
import * as actions from './actions';

const state = {
    tasks: []
}

const getters = {
    taskflowTasks : state => state.tasks
}

const mutations = {
    [types.GET_TASKFLOW_DATA](state, tasks){
        state.tasks = tasks
    }
}

export default {
    state, 
    actions,
    getters,
    mutations
}